import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {RouterProvider} from '@tanstack/react-router';
import {StrictMode} from 'react';
import {_theme, BlobApiProvider} from 'shared';
import {ThemeProvider} from 'styled-components';

import {WindowsProvider} from '@/components/WindowProvider/WindowsProvider';
import {useAppTheme} from '@/hooks/useAppTheme';
import {blobApi} from '@/lib/ky';
import {AppErrorBoundary} from '@/lib/react-error-boundary';
import {queryClient} from '@/lib/react-query';
import {router} from '@/router/router';

import {AuthProvider} from './AuthProvider';

export function AppProvider(): React.JSX.Element {
  useAppTheme();

  return (
    <StrictMode>
      <ThemeProvider theme={_theme}>
        <BlobApiProvider blobApi={blobApi}>
          <AppErrorBoundary>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools
                buttonPosition="bottom-left"
                client={queryClient}
              />

              <WindowsProvider>
                <AuthProvider>
                  <RouterProvider router={router} />
                </AuthProvider>
              </WindowsProvider>
            </QueryClientProvider>
          </AppErrorBoundary>{' '}
        </BlobApiProvider>
      </ThemeProvider>
    </StrictMode>
  );
}

AppProvider.displayName = 'AppProvider';
